var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {

            $('.blog-listing .container .row').each(function() {
                if ($(this).children().length <= 0) {
                    $(this).closest('.blog-listing').addClass('is-empty');
                }
            });

            if (!(window.location.href.indexOf("/page/") > -1)) {
                $('.blog-listing-recent-post').addClass('is-visible');
            }
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=blog-listing', initializeBlock);
    }
});
